import { WorryRoom } from '@/components/features/wellbeing/worry/WorryRoom';

/** /wellbeing/worry - write it down, set it aside. */
export function WorryRoomPage() {
  return <WorryRoom />;
}
